import { useEventStore } from "@/event";
import { EventUpgradeIds } from "@/game/entities/config/upgrades/";
import useUpgradesStore from "@/store/useUpgradesStore";
import { EventCategory } from "@/types/ui";

/** Christmas mountain lumberjack upgrade gates OLD_FOREST-style lumber on hills/mountains. */
export function isChristmasMountainLumberjackActive(): boolean {
	const { isActive, attributes } = useEventStore();
	return (
		!!(isActive && attributes.type === EventCategory.CHRISTMAS) &&
		useUpgradesStore().getCurrentLevelById(
			EventUpgradeIds.ch_mountain_lumberjacks,
		) > 0
	);
}
